import dayjs from 'dayjs';
import { useFormContext } from 'react-hook-form';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import useUpdateEffect from '@/hooks/useUpdateEffect';
import type { DeliverableChangeOrderSchema } from './validationSchema';

export function ChangeInDaysInput() {
  const formMethods = useFormContext<DeliverableChangeOrderSchema>();
  const deliverable = formMethods.watch('deliverable');
  const proposedDueDate = formMethods.watch('proposedDueDate');

  useUpdateEffect(() => {
    if (deliverable?.dueDate) {
      const diffInDays = dayjs(proposedDueDate).diff(dayjs(deliverable.dueDate).startOf('day'), 'day', true);

      formMethods.setValue('changeInDays', diffInDays);
    } else {
      formMethods.setValue('changeInDays', 0);
    }
  }, [deliverable, proposedDueDate]);

  return <HookInput formMethods={formMethods} label='Change in Days' disabled type='number' id='changeInDays' name='changeInDays' />;
}
